// import React from 'react';
// import styled from 'styled-components';
// import { Col } from 'styled-bootstrap-grid';
// import ContentContainer from '../global/contentContainer';
// import { useStaticQuery, graphql } from 'gatsby';
// import FilterIcon from '../icons/filter-icon';

// const ViewContainer = styled.div`
//   margin: 0 0 54px 0;
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   @media (max-width: 767px) {
//     margin: 0;
//   }
// `;
// const ViewOption = styled.button`
//   max-width: 230px;
//   width: 100%;
//   height: 50px;
//   cursor: pointer;
//   border-radius: 25px;
//   border: 0;
//   background-color: #3c82e6;
//   color: #fff;
//   padding: 0;
//   margin: 0;
//   float: right;
//   line-height: 47px;
//   font-size: 20px;
//   display: flex;
//   justify-content: center;
//   &:hover {
//     background-color: #000;
//   }
//   @media (max-width: 767px) {
//     max-width: 170px;
//     width: 100%;
//     height: 40px;
//     line-height: 39px;
//     font-size: 16px;
//   }
//   @media (max-width: 575px) {
//     float: none;
//     margin: 0 auto;
//   }
// `;

// const ActiveViewContainer = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: row;
//   justify-content: flex-end;
// `;

// const ActiveViewOption = styled(ViewOption)`
//   background-color: #000;
//   & > span {
//     height: 50px;
//     margin-right: 16px;
//   }
// `;

// const FiltersContainer = styled.div`
//   width: 100%;
//   position: relative;
// `;

// const ListFilters = styled.div`
//   margin-top: 54px;
//   position: relative;
//   @media (max-width: 575px) {
//     margin-top: 40px;
//   }
// `;

// const FilterHeading = styled.h3`
//   text-align: left;
//   text-transform: uppercase;
//   margin-bottom: 34px;
//   @media (max-width: 767px) {
//     font-size: 15px;
//     margin-bottom: 10px;
//   }
// `;

// const FilterHeaders = styled.div`
//   text-align: left;
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   position: relative;
// `;

// const FilterColumn = styled.div`
//   // flex: 1;
//   position: relative;
//   @media (max-width: 767px) {
//     font-size: 15px;
//     flex: 1 45%;
//     margin-bottom: 20px;
//     &:nth-of-type(odd) {
//       padding-right: 10px;
//     }
//     &:nth-of-type(even) {
//       padding-left: 10px;
//     }
//   }
// `;

// const ColumnContent = styled.div`
//   position: relative;
//   & > label {
//     cursor: pointer;
//   }
//   &:hover > label {
//     color: #9ec1f3;
//   }
//   color: #3c82e6;
//   & input {
//     position: absolute;
//     opacity: 0;
//     cursor: pointer;
//     height: 0;
//     width: 0;
//     &:checked ~ span:first-of-type {
//       &:after {
//         content: '☒';
//         color: #9ec1f3;
//       }
//     }
//     &:checked ~ span {
//       color: #9ec1f3;
//     }
//   }
// `;

// const InputLabel = styled.span`
//   margin-left: 22px;
// `;

// const CheckMark = styled.span`
//   position: absolute;
//   top: 0;
//   left: 0;
//   height: 20px;
//   width: 20px;
//   cursor: pointer;
//   &:after {
//     content: '☑';
//     position: absolute;
//     // display: none;
//     left: 0;
//     top: 0;
//     width: 20px;
//     height: 20px;
//   }
// `;

// const ToggleFilters = styled(ColumnContent)`
//   position: relative;
//   margin-bottom: 1em;
//   color: #000;
// `;

// const FilterView = ({
//   onClick,
//   toggleActive,
//   toggleFilterValue,
//   toggleAllFiltersOfType,
//   checkedItems,
//   eventsList,
// }) => {
//   if (eventsList !== null) {
//     const allActiveTutors = Array.from(
//       new Set(
//         eventsList
//           .filter(
//             tutor =>
//               tutor.node.data.tutor !== undefined &&
//               tutor.node.data.tutor !== null
//           )
//           .filter(tutor => tutor.node.data.tutor.document !== null)
//           .filter(tutor => tutor.node.data.tutor.document.data !== undefined)
//           .map(tutor => {
//             return tutor.node.data.tutor.document.data.name.text;
//           })
//       )
//     ).sort();

//     const allTutors = allActiveTutors.map((tutor, index) => {
//       return (
//         <ColumnContent key={`tutor_${index}`}>
//           <label>
//             <input
//               name={tutor}
//               type="checkbox"
//               checked={checkedItems.get(tutor)}
//               onChange={e => toggleFilterValue(e.target)}
//             />
//             <CheckMark />
//             <InputLabel>{tutor}</InputLabel>
//           </label>
//         </ColumnContent>
//       );
//     });

//     const allActiveLocations = Array.from(
//       new Set(
//         eventsList
//           .filter(location => location.node.data.location !== null)
//           .filter(location => location.node.data.location.document !== null)
//           .filter(
//             location => location.node.data.location.document.data !== undefined
//           )
//           .map(location => {
//             return location.node.data.location.document.data.title.text;
//           })
//       )
//     ).sort();

//     const allLocations = allActiveLocations.map((location, index) => {
//       return (
//         <ColumnContent key={`location_${index}`}>
//           <label>
//             <input
//               name={location}
//               type="checkbox"
//               checked={checkedItems.get(location)}
//               onChange={e => toggleFilterValue(e.target)}
//             />
//             <CheckMark />

//             <InputLabel>{location}</InputLabel>
//           </label>
//         </ColumnContent>
//       );
//     });

//     const allActiveClassTypes = Array.from(
//       new Set(
//         eventsList.map(classType => {
//           return classType.node.data.class_categories
//             .filter(checkClasses => checkClasses.class_type !== null)
//             .filter(filterClasses => filterClasses.class_type.document !== null)
//             .filter(
//               filterClasses =>
//                 filterClasses.class_type.document.data !== undefined
//             )
//             .map(singleClassType => {
//               return singleClassType.class_type.document.data.title.text;
//             });
//         })
//       )
//     );

//     const mergedActiveClassTypes = Array.from(
//       new Set([].concat.apply([], allActiveClassTypes))
//     ).sort();

//     const allClassTypes = mergedActiveClassTypes.map((classType, index) => {
//       return (
//         <ColumnContent key={index}>
//           <label>
//             <input
//               name={classType}
//               type="checkbox"
//               checked={checkedItems.get(classType)}
//               onChange={e => toggleFilterValue(e.target)}
//             />
//             <CheckMark />

//             <InputLabel>{classType}</InputLabel>
//           </label>
//         </ColumnContent>
//       );
//     });

//     const allActiveTuition = Array.from(
//       new Set(
//         eventsList.map(tuition => {
//           return tuition.node.data.tuition_categories
//             .filter(checkTuition => checkTuition.tuition !== null)
//             .filter(singleTuition => singleTuition.tuition.document !== null)
//             .filter(
//               singleTuition => singleTuition.tuition.document.data !== undefined
//             )
//             .map(singleTuition => {
//               return singleTuition.tuition.document.data.title.text;
//             });
//         })
//       )
//     );

//     const mergedActiveTuition = Array.from(
//       new Set([].concat.apply([], allActiveTuition))
//     ).sort();

//     const allTuition = mergedActiveTuition.map((tuition, index) => {
//       return (
//         <ColumnContent key={index}>
//           <label>
//             <input
//               name={tuition}
//               type="checkbox"
//               checked={checkedItems.get(tuition)}
//               onChange={e => toggleFilterValue(e.target)}
//             />
//             <CheckMark />

//             <InputLabel>{tuition}</InputLabel>
//           </label>
//         </ColumnContent>
//       );
//     });

//     const allActiveSubjects = Array.from(
//       new Set(
//         eventsList.map(subject => {
//           return subject.node.data.subject_categories
//             .filter(checkSubjects => checkSubjects.subject !== null)
//             .filter(checkSubjects => checkSubjects.subject.document !== null)
//             .filter(
//               checkSubjects => checkSubjects.subject.document.data !== undefined
//             )
//             .map(singleSubject => {
//               return singleSubject.subject.document.data.title.text;
//             });
//         })
//       )
//     );

//     const mergedActiveSubjects = Array.from(
//       new Set([].concat.apply([], allActiveSubjects))
//     ).sort();

//     const allSubjects = mergedActiveSubjects.map((subject, index) => {
//       return (
//         <ColumnContent key={index}>
//           <label>
//             <input
//               name={subject}
//               type="checkbox"
//               checked={checkedItems.get(subject)}
//               onChange={e => toggleFilterValue(e.target)}
//             />
//             <CheckMark />

//             <InputLabel>{subject}</InputLabel>
//           </label>
//         </ColumnContent>
//       );
//     });

//     return (
//       <React.Fragment>
//         <Col col={12} sm={4}>
//           {toggleActive === true ? (
//             <ActiveViewContainer>
//               <ActiveViewOption onClick={() => onClick()}>
//                 <span>✕</span> Filter Classes
//               </ActiveViewOption>
//             </ActiveViewContainer>
//           ) : (
//             <ViewOption onClick={() => onClick()}>
//               <FilterIcon fill={'#fff'} />
//               Filter Classes
//             </ViewOption>
//           )}
//         </Col>

//         <Col col={12}>
//           {toggleActive === true ? (
//             <ContentContainer padding={'0'} mobilePadding={'0'}>
//               <ViewContainer>
//                 <FiltersContainer>
//                   <ListFilters>
//                     <FilterHeaders>
//                       <FilterColumn>
//                         <FilterHeading>Tuition</FilterHeading>
//                         <ToggleFilters>
//                           <label>
//                             <input
//                               name="allTuition"
//                               type="checkbox"
//                               checked={checkedItems.get('allTuition')}
//                               onChange={e =>
//                                 toggleAllFiltersOfType(
//                                   mergedActiveTuition,
//                                   e.target
//                                 )
//                               }
//                             />
//                             <CheckMark />
//                             <InputLabel>All / None</InputLabel>
//                           </label>
//                         </ToggleFilters>
//                         {allTuition}
//                       </FilterColumn>

//                       <FilterColumn>
//                         <FilterHeading>Tutor</FilterHeading>
//                         <ToggleFilters>
//                           <label>
//                             <input
//                               name="allTutors"
//                               type="checkbox"
//                               checked={checkedItems.get('allTutors')}
//                               onChange={e =>
//                                 toggleAllFiltersOfType(
//                                   allActiveTutors,
//                                   e.target
//                                 )
//                               }
//                             />
//                             <CheckMark />
//                             <InputLabel>All / None</InputLabel>
//                           </label>
//                         </ToggleFilters>
//                         {allTutors}
//                       </FilterColumn>

//                       <FilterColumn>
//                         <FilterHeading>Location</FilterHeading>
//                         <ToggleFilters>
//                           <label>
//                             <input
//                               name="allLocations"
//                               type="checkbox"
//                               checked={checkedItems.get('allLocations')}
//                               onChange={e =>
//                                 toggleAllFiltersOfType(
//                                   allActiveLocations,
//                                   e.target
//                                 )
//                               }
//                             />
//                             <CheckMark />
//                             <InputLabel>All / None</InputLabel>
//                           </label>
//                         </ToggleFilters>
//                         {allLocations}
//                       </FilterColumn>

//                       <FilterColumn>
//                         <FilterHeading>Class Type</FilterHeading>
//                         <ToggleFilters>
//                           <label>
//                             <input
//                               name="allClassTypes"
//                               type="checkbox"
//                               checked={checkedItems.get('allClassTypes')}
//                               onChange={e =>
//                                 toggleAllFiltersOfType(
//                                   mergedActiveClassTypes,
//                                   e.target
//                                 )
//                               }
//                             />
//                             <CheckMark />
//                             <InputLabel>All / None</InputLabel>
//                           </label>
//                         </ToggleFilters>
//                         {allClassTypes}
//                       </FilterColumn>

//                       <FilterColumn>
//                         <FilterHeading>Subject</FilterHeading>
//                         <ToggleFilters>
//                           <label>
//                             <input
//                               name="allSubjects"
//                               type="checkbox"
//                               checked={checkedItems.get('allSubjects')}
//                               onChange={e =>
//                                 toggleAllFiltersOfType(
//                                   mergedActiveSubjects,
//                                   e.target
//                                 )
//                               }
//                             />
//                             <CheckMark />
//                             <InputLabel>All / None</InputLabel>
//                           </label>
//                         </ToggleFilters>
//                         {allSubjects}
//                       </FilterColumn>
//                     </FilterHeaders>
//                   </ListFilters>
//                 </FiltersContainer>
//               </ViewContainer>
//             </ContentContainer>
//           ) : null}
//         </Col>
//       </React.Fragment>
//     );
//   } else {
//     return null;
//   }
// };

// export default FilterView;

import React from 'react';
import styled from 'styled-components';
import { Col } from 'styled-bootstrap-grid';
import ContentContainer from '../global/contentContainer';
import { useStaticQuery, graphql } from 'gatsby';
import FilterIcon from '../icons/filter-icon';

const ViewContainer = styled.div`
  margin: 0 0 54px 0;
  position: relative;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    margin: 0;
  }
`;
const ViewOption = styled.button`
  max-width: 230px;
  width: 100%;
  height: 50px;

  cursor: pointer;

  border-radius: 25px;
  border: 0;

  background-color: #3c82e6;
  color: #fff;

  padding: 0;
  margin: 0;

  float: right;

  line-height: 47px;
  font-size: 20px;

  display: flex;
  justify-content: center;

  &:hover {
    background-color: #000;
  }

  @media (max-width: 767px) {
    max-width: 170px;
    width: 100%;
    height: 40px;

    line-height: 39px;
    font-size: 16px;
  }

  @media (max-width: 575px) {
    float: none;
    margin: 0 auto;
  }
`;

const ActiveViewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const ActiveViewOption = styled(ViewOption)`
  background-color: #000;

  & > span {
    height: 50px;
    margin-right: 16px;
  }
`;

const FiltersContainer = styled.div`
  width: 100%;
  position: relative;
`;

const ListFilters = styled.div`
  margin-top: 54px;
  position: relative;

  @media (max-width: 575px) {
    margin-top: 40px;
  }
`;

const FilterHeading = styled.h3`
  text-align: left;
  text-transform: uppercase;

  margin-bottom: 34px;

  @media (max-width: 767px) {
    font-size: 15px;
    margin-bottom: 10px;
  }
`;

const FilterHeaders = styled.div`
  text-align: left;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  position: relative;
`;

const FilterColumn = styled.div`
  // flex: 1;

  position: relative;

  @media (max-width: 767px) {
    font-size: 15px;

    flex: 1 45%;
    margin-bottom: 20px;

    &:nth-of-type(odd) {
      padding-right: 10px;
    }
    &:nth-of-type(even) {
      padding-left: 10px;
    }
  }
`;

const ColumnContent = styled.div`
  position: relative;

  & > label {
    cursor: pointer;
  }

  &:hover > label {
    color: #9ec1f3;
  }

  color: #3c82e6;
  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ span:first-of-type {
      &:after {
        content: '☒';
        color: #9ec1f3;
      }
    }
    &:checked ~ span {
      color: #9ec1f3;
    }
  }
`;

const InputLabel = styled.span`
  margin-left: 22px;
`;

const CheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;

  cursor: pointer;

  &:after {
    content: '☑';
    position: absolute;
    // display: none;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
`;

const ToggleFilters = styled(ColumnContent)`
  position: relative;
  margin-bottom: 1em;
  color: #000;
`;

const FilterView = ({
  onClick,
  toggleActive,
  toggleFilterValue,
  toggleAllFiltersOfType,
  checkedItems,
  eventsList,
}) => {
  if (eventsList !== null) {
    const allActiveTutors = Array.from(
      new Set(
        eventsList
          .filter(
            tutor =>
              tutor.node.data.tutor !== undefined &&
              tutor.node.data.tutor !== null
          )
          .filter(tutor => tutor.node.data.tutor.document !== null)
          .filter(tutor => tutor.node.data.tutor.document.data !== undefined)
          .map(tutor => tutor.node.data.tutor.document.data.name.text)
      )
    ).sort();

    const allTutors = allActiveTutors.map((tutor, index) => {
      return (
        <ColumnContent key={`tutor_${index}`}>
          <label>
            <input
              name={tutor}
              type="checkbox"
              checked={checkedItems.get(tutor)}
              onChange={e => toggleFilterValue(e.target)}
            />
            <CheckMark />
            <InputLabel>{tutor}</InputLabel>
          </label>
        </ColumnContent>
      );
    });

    const allActiveLocations = Array.from(
      new Set(
        eventsList
          .filter(location => location.node.data.location !== null)
          .filter(location => location.node.data.location.document !== null)

          .filter(
            location => location.node.data.location.document.data !== undefined
          )
          .map(location => location.node.data.location.document.data.title.text)
      )
    ).sort();

    const allLocations = allActiveLocations.map((location, index) => {
      return (
        <ColumnContent key={`location_${index}`}>
          <label>
            <input
              name={location}
              type="checkbox"
              checked={checkedItems.get(location)}
              onChange={e => toggleFilterValue(e.target)}
            />
            <CheckMark />

            <InputLabel>{location}</InputLabel>
          </label>
        </ColumnContent>
      );
    });

    const allActiveClassTypes = Array.from(
      new Set(
        eventsList.map(classType => {
          return classType.node.data.class_categories
            .filter(checkClasses => checkClasses.class_type !== null)
            .filter(filterClasses => filterClasses.class_type.document !== null)
            .filter(
              filterClasses =>
                filterClasses.class_type.document.data !== undefined
            )

            .map(
              singleClassType =>
                singleClassType.class_type.document.data.title.text
            );
        })
      )
    );

    const mergedActiveClassTypes = Array.from(
      new Set([].concat.apply([], allActiveClassTypes))
    ).sort();

    const allClassTypes = mergedActiveClassTypes.map((classType, index) => {
      return (
        <ColumnContent key={index}>
          <label>
            <input
              name={classType}
              type="checkbox"
              checked={checkedItems.get(classType)}
              onChange={e => toggleFilterValue(e.target)}
            />
            <CheckMark />

            <InputLabel>{classType}</InputLabel>
          </label>
        </ColumnContent>
      );
    });

    const allActiveTuition = Array.from(
      new Set(
        eventsList.map(tuition => {
          return tuition.node.data.tuition_categories
            .filter(checkTuition => checkTuition.tuition !== null)
            .filter(singleTuition => singleTuition.tuition.document !== null)
            .filter(
              singleTuition => singleTuition.tuition.document.data !== undefined
            )
            .map(
              singleTuition => singleTuition.tuition.document.data.title.text
            );
        })
      )
    );

    const mergedActiveTuition = Array.from(
      new Set([].concat.apply([], allActiveTuition))
    ).sort();

    const allTuition = mergedActiveTuition.map((tuition, index) => {
      return (
        <ColumnContent key={index}>
          <label>
            <input
              name={tuition}
              type="checkbox"
              checked={checkedItems.get(tuition)}
              onChange={e => toggleFilterValue(e.target)}
            />
            <CheckMark />

            <InputLabel>{tuition}</InputLabel>
          </label>
        </ColumnContent>
      );
    });

    const allActiveSubjects = Array.from(
      new Set(
        eventsList.map(subject => {
          return subject.node.data.subject_categories
            .filter(checkSubjects => checkSubjects.subject !== null)
            .filter(checkSubjects => checkSubjects.subject.document !== null)
            .filter(
              checkSubjects => checkSubjects.subject.document !== undefined
            )
            .filter(
              checkSubjects => checkSubjects.subject.document.data !== undefined
            )
            .map(
              singleSubject => singleSubject.subject.document.data.title.text
            );
        })
      )
    );

    const mergedActiveSubjects = Array.from(
      new Set([].concat.apply([], allActiveSubjects))
    ).sort();

    const allSubjects = mergedActiveSubjects.map((subject, index) => {
      return (
        <ColumnContent key={index}>
          <label>
            <input
              name={subject}
              type="checkbox"
              checked={checkedItems.get(subject)}
              onChange={e => toggleFilterValue(e.target)}
            />
            <CheckMark />

            <InputLabel>{subject}</InputLabel>
          </label>
        </ColumnContent>
      );
    });

    return (
      <React.Fragment>
        <Col col={12} sm={4}>
          {toggleActive === true ? (
            <ActiveViewContainer>
              <ActiveViewOption onClick={() => onClick()}>
                <span>✕</span> Filter Classes
              </ActiveViewOption>
            </ActiveViewContainer>
          ) : (
            <ViewOption onClick={() => onClick()}>
              <FilterIcon fill={'#fff'} />
              Filter Classes
            </ViewOption>
          )}
        </Col>

        <Col col={12}>
          {toggleActive === true ? (
            <ContentContainer padding={'0'} mobilePadding={'0'}>
              <ViewContainer>
                <FiltersContainer>
                  <ListFilters>
                    <FilterHeaders>
                      <FilterColumn>
                        <FilterHeading>Tuition</FilterHeading>
                        <ToggleFilters>
                          <label>
                            <input
                              name="allTuition"
                              type="checkbox"
                              checked={checkedItems.get('allTuition')}
                              onChange={e =>
                                toggleAllFiltersOfType(
                                  mergedActiveTuition,
                                  e.target
                                )
                              }
                            />
                            <CheckMark />
                            <InputLabel>All / None</InputLabel>
                          </label>
                        </ToggleFilters>
                        {allTuition}
                      </FilterColumn>

                      <FilterColumn>
                        <FilterHeading>Tutor</FilterHeading>
                        <ToggleFilters>
                          <label>
                            <input
                              name="allTutors"
                              type="checkbox"
                              checked={checkedItems.get('allTutors')}
                              onChange={e =>
                                toggleAllFiltersOfType(
                                  allActiveTutors,
                                  e.target
                                )
                              }
                            />
                            <CheckMark />
                            <InputLabel>All / None</InputLabel>
                          </label>
                        </ToggleFilters>
                        {allTutors}
                      </FilterColumn>

                      <FilterColumn>
                        <FilterHeading>Location</FilterHeading>
                        <ToggleFilters>
                          <label>
                            <input
                              name="allLocations"
                              type="checkbox"
                              checked={checkedItems.get('allLocations')}
                              onChange={e =>
                                toggleAllFiltersOfType(
                                  allActiveLocations,
                                  e.target
                                )
                              }
                            />
                            <CheckMark />
                            <InputLabel>All / None</InputLabel>
                          </label>
                        </ToggleFilters>
                        {allLocations}
                      </FilterColumn>

                      <FilterColumn>
                        <FilterHeading>Class Type</FilterHeading>
                        <ToggleFilters>
                          <label>
                            <input
                              name="allClassTypes"
                              type="checkbox"
                              checked={checkedItems.get('allClassTypes')}
                              onChange={e =>
                                toggleAllFiltersOfType(
                                  mergedActiveClassTypes,
                                  e.target
                                )
                              }
                            />
                            <CheckMark />
                            <InputLabel>All / None</InputLabel>
                          </label>
                        </ToggleFilters>
                        {allClassTypes}
                      </FilterColumn>

                      <FilterColumn>
                        <FilterHeading>Subject</FilterHeading>
                        <ToggleFilters>
                          <label>
                            <input
                              name="allSubjects"
                              type="checkbox"
                              checked={checkedItems.get('allSubjects')}
                              onChange={e =>
                                toggleAllFiltersOfType(
                                  mergedActiveSubjects,
                                  e.target
                                )
                              }
                            />
                            <CheckMark />
                            <InputLabel>All / None</InputLabel>
                          </label>
                        </ToggleFilters>
                        {allSubjects}
                      </FilterColumn>
                    </FilterHeaders>
                  </ListFilters>
                </FiltersContainer>
              </ViewContainer>
            </ContentContainer>
          ) : null}
        </Col>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default FilterView;
